<form [formGroup]="parent">
    <div>
        <div class="col-md-12 clear-all margin-top-30 form-field" *ngIf="parent.get('userTitle').value === 'Other'">
            <div class="form-field  clear-all" [ngClass]="{'has-error': parent.get('otherTitle').touched
              && parent.get('otherTitle').errors}">
                <div class="dropdown-control">
                    <label id="othTitle"> Other title</label>

                </div>
                <div class="form-field-select">

                    <select id="beneficiary-otherTitle" formControlName="otherTitle" class="form-control some"
                        aria-invalid="false"
                        [ngModel]="parent.get('otherTitle') ? parent.get('otherTitle').value : null">

                        <option [disabled]="false" [ngValue]="null">Please select</option>
                        <option *ngFor="let otherTitle of otherTitleList" [value]="otherTitle.description">
                            {{otherTitle.description}}</option>
                    </select>
                    <i class="icon icon-chevron-down" aria-hidden="true"></i>
                </div>

                <div class="form-validation-error" *ngIf="parent.get('otherTitle').touched
                                    && parent.get('otherTitle').errors 
                                    && parent.get('otherTitle').hasError('required')">
                    <i class="icon icon-error" aria-hidden="true"></i>
                    <p>Please select other title</p>
                </div>
            </div>
        </div>

    </div>
</form>